import React from "react";
import Step from "components/MainApp/atoms/Wizard/Step";
import renderInput from "helpers/FormGenerator";

import styles from "./LoadReceptionOrder.step1.module.scss";
import i18n from "i18n";

export const ReceptionOrderStep1 = ({ handleChange, handleSelect, fields }) => {
  const stepContent = (
    <div className={styles["reception-order-step-one-content"]}>
      {fields &&
        fields.map((field) => {
          return renderInput(
            field,
            handleSelect,
            handleChange,
            "reception-order-field"
          );
        })}
    </div>
  );
  return (
    <div className={styles["reception-order-step-one-container"]}>
      <Step title={i18n.t("enter.order.details")} content={stepContent} paddingVariant="orders-padding"></Step>
    </div>
  );
};

export default ReceptionOrderStep1;
